import { FC, useState } from "react";
import { Table } from "antd";
import { UsersTableColumns } from "./columns";
import styles from "./UsersTable.module.css";
import { PermissionsEditModal } from "../PermissionsEdit/PermissionsEditModal";
import { Role, UserManagement } from "../../../../types/user-management";

interface Props {
  data: UserManagement[];
  isLoading: boolean;
  onUserEdited: (id: number, roles: Role[]) => void;
}

export const UsersTable: FC<Props> = ({ data, isLoading, onUserEdited }) => {
  const [visibleEdit, setVisibleEdit] = useState<boolean>(false);
  const [userEdit, setUserEdit] = useState<undefined | UserManagement>(undefined);

  const onUserSelected = (id: number) => {
    const user = data.find((user) => user.id === id);
    setUserEdit(user);
    setVisibleEdit(true);
  };


  
  return (
    <>
      <Table
        className="no-pagination"
        columns={UsersTableColumns(onUserSelected)}
        dataSource={data ? data : []}
        size="small"
        bordered
        pagination={{
          total: data.length,
          defaultPageSize: data.length,
          current: 1,
          showSizeChanger: true,
          pageSizeOptions: [data.length]
        }}
        loading={isLoading}
        rowClassName={`${styles.stripedRow}`}
        rowKey={"id"}
        sticky
      />
      <PermissionsEditModal
        onUserEdited={onUserEdited}
        setVisibleEdit={setVisibleEdit}
        visibleEdit={visibleEdit}
        user={userEdit}
        setUserEdit={setUserEdit}
      ></PermissionsEditModal>
    </>
  );
};
